import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class ForInvestorsEvent extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get subtitle() {
    return get(this, '_podtytul.value', '');
  }

  get date() {
    const date = get(this, '_data.value', '');
    const makeDate = new Date(date);

    return {
      day: makeDate.getDate(),
      month: makeDate.toLocaleString('pl-PL', { month: 'short' }).toUpperCase(),
      year: makeDate.getFullYear()
    };
  }

  get link() {
    return get(this, '_plik.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ForInvestorsEvent.model.js